import { RouterProvider, createBrowserRouter } from "react-router-dom";
import AppErrorBoundary from "@/components/app/AppErrorBoundary";
import { route } from "./route";
import Sidebar from "@/components/dashboard/Sidebar";

const router = createBrowserRouter([
  {
    path: "/",
    lazy: () => route(import("../components/login/Login")),
    ErrorBoundary: AppErrorBoundary,
  },
  {
    path: "/login",
    lazy: () => route(import("../components/login/Login")),
    ErrorBoundary: AppErrorBoundary,
  },
  {
    path: "/register",
    lazy: () => route(import("../components/register/Register")),
    ErrorBoundary: AppErrorBoundary,
  },
  {
    path: "/dashboard",
    element: <Sidebar />,
    ErrorBoundary: AppErrorBoundary,
    children: [
      {
        index: true,
        lazy: () => route(import("../components/dashboard/Home")),
      },
      {
        path: "home",
        lazy: () => route(import("../components/dashboard/Home")),
      },
      {
        path: "users",
        lazy: () => route(import("../components/dashboard/users/UsersNew")),
        ErrorBoundary: AppErrorBoundary,
      },
      {
        path: "users/:id",
        lazy: () => route(import("../components/dashboard/users/UserDetail")),
        ErrorBoundary: AppErrorBoundary,
      },
      {
        path: "wallets",
        lazy: () => route(import("../components/dashboard/wallets/Wallets")),
        ErrorBoundary: AppErrorBoundary,
      },
      {
        path: "ledger-accounts",
        lazy: () => route(import("../components/dashboard/ledger/LedgerAccounts")),
        ErrorBoundary: AppErrorBoundary,
      },
      {
        path: "finance",
        lazy: () => route(import("../components/dashboard/finance/Finance")),
        ErrorBoundary: AppErrorBoundary,
      },
    ],
  },
]);

const Routes = () => {
  return <RouterProvider router={router} />;
};

export default Routes;
